export default {
    "en": {
        "All_Promotion_Landing_Title1_Product_Title1": "1 YEAR",
        "All_Promotion_Landing_Title1_Product_Description1": "/mo*",
        "All_Promotion_Landing_Title1_Product_Description2": "Limited Time Offer!",
        "All_Promotion_Landing_Title1_Product_Description3": "*Billed as one time payment of %@",
        "All_Promotion_Landing_Title1_Product_Description4": "No automatic renewal.",
        "All_Promotion_Landing_Title1_Product_Title2": "2 YEARS",
        "All_Promotion_Landing_Title1_Product_Description5": "*Billed as one time payment of %@",
        "All_Promotion_Landing_body1_message1": "The special gift has arrived",
        "All_Promotion_Landing_body1_message2": "Limited Time Offer!",
        "All_Promotion_Landing_body1_message3": "days",
        "All_Promotion_Landing_body1_message4": "hours",
        "All_Promotion_Landing_body1_message5": "minutes",
        "All_Promotion_Landing_body1_message6": "seconds",
        "All_Promotion_Landing_body1_message7": "Todo Math one-year pass discount gift",
        "All_Promotion_Landing_body1_message8": "Regular price",
        "All_Promotion_Landing_body1_message9": "Non-recurring Annual Subscription (paid in full)",
        "All_Promotion_Landing_body1_message10": "To cancel your membership and request a refund, please visit \"Todo Math Webpage > Help> Contact us\" (Refund Policy : Customers may cancel the membership for a full refund within 7days of a purchase / A pro-rata (daily calculation) refund will be made between 8 and 90 days of a purchase / No refund is availabe after 90 days of a purchase)",
        "All_Promotion_Landing_body1_message11": "Get it Now",
        "All_Promotion_Landing_body1_message12": "Todo Math pass is successfully issued. Transaction history can be found under Todo Math app’s Parents Page."
    },
    "ko": {
        "All_Promotion_Landing_Title1_Product_Title1": "1년",
        "All_Promotion_Landing_Title1_Product_Description1": "/월*",
        "All_Promotion_Landing_Title1_Product_Description2": "Limited Time Offer!",
        "All_Promotion_Landing_Title1_Product_Description3": "*총 결제 금액 %@",
        "All_Promotion_Landing_Title1_Product_Description4": "자동 갱신되지 않습니다.",
        "All_Promotion_Landing_Title1_Product_Title2": "2 년",
        "All_Promotion_Landing_Title1_Product_Description5": "*총 결제 금액 %@",
        "All_Promotion_Landing_body1_message1": "고객님께 특별한 선물이 도착했어요.",
        "All_Promotion_Landing_body1_message2": "Limited Time Offer!",
        "All_Promotion_Landing_body1_message3": "일",
        "All_Promotion_Landing_body1_message4": "시간",
        "All_Promotion_Landing_body1_message5": "분",
        "All_Promotion_Landing_body1_message6": "초",
        "All_Promotion_Landing_body1_message7": "토도수학 1년 이용권 할인쿠폰",
        "All_Promotion_Landing_body1_message8": "정상가",
        "All_Promotion_Landing_body1_message9": "이용권은 선불로 1회만 결제되며, 자동 갱신되지 않습니다. ",
        "All_Promotion_Landing_body1_message10": "결제 취소 및 환불 요청은 '토도수학 홈페이지 > 도움말 > 문의하기'를 이용해 주세요. (결제 후 7일 이내  요청 시 전액 환불, 결제 후 7일 초과 90일 이내 요청 시 일할 계산하여 부분 환불, 결제 후 90일 초과 요청 시 환불 불가)",
        "All_Promotion_Landing_body1_message11": "결제하기",
        "All_Promotion_Landing_body1_message12": "토도수학 이용권이 정상 결제 되었습니다.\n구매내역은 토도수학 앱 > 부모페이지에서 확인하실 수 있습니다."
    },
    "cn": {
        "All_Promotion_Landing_Title1_Product_Title1": "1年",
        "All_Promotion_Landing_Title1_Product_Description1": "/月*",
        "All_Promotion_Landing_Title1_Product_Description2": "限时折扣活动！",
        "All_Promotion_Landing_Title1_Product_Description3": "*一次性支付 %@",
        "All_Promotion_Landing_Title1_Product_Description4": "不自动续费",
        "All_Promotion_Landing_Title1_Product_Title2": "2年",
        "All_Promotion_Landing_Title1_Product_Description5": "*一次性支付 %@",
        "All_Promotion_Landing_body1_message1": "您有一份特别礼物",
        "All_Promotion_Landing_body1_message2": "限时折扣活动！",
        "All_Promotion_Landing_body1_message3": "天",
        "All_Promotion_Landing_body1_message4": "时",
        "All_Promotion_Landing_body1_message5": "分",
        "All_Promotion_Landing_body1_message6": "秒",
        "All_Promotion_Landing_body1_message7": "都都数学年卡折扣卷",
        "All_Promotion_Landing_body1_message8": "原价",
        "All_Promotion_Landing_body1_message9": "非自动续费年度订阅（一次性支付）",
        "All_Promotion_Landing_body1_message10": "取消付款或退款请参考在都都数学官网中的帮助>常见问题。（付款后7天内可全额退款，付款后7天以上90天内申请退款按使用天数折算扣费后退还剩余费用，付款后超过90天无法退款）",
        "All_Promotion_Landing_body1_message11": "现在购买",
        "All_Promotion_Landing_body1_message12": "都都数学年卡购买成功。\n购买历史可在都都数学App家长页面查看"
    },
    "ja": {
        "All_Promotion_Landing_Title1_Product_Title1": "1年",
        "All_Promotion_Landing_Title1_Product_Description1": "/月*",
        "All_Promotion_Landing_Title1_Product_Description2": "タイムセール！",
        "All_Promotion_Landing_Title1_Product_Description3": "*決済額 %@",
        "All_Promotion_Landing_Title1_Product_Description4": "自動更新はされません。",
        "All_Promotion_Landing_Title1_Product_Title2": "2年",
        "All_Promotion_Landing_Title1_Product_Description5": "*決済額 %@",
        "All_Promotion_Landing_body1_message1": "会員のお客さまに特別なプレゼントをお送りします。",
        "All_Promotion_Landing_body1_message2": "タイムセール！",
        "All_Promotion_Landing_body1_message3": "日",
        "All_Promotion_Landing_body1_message4": "時間",
        "All_Promotion_Landing_body1_message5": "分",
        "All_Promotion_Landing_body1_message6": "秒",
        "All_Promotion_Landing_body1_message7": "トドさんすう1年ライセンス割引クーポン",
        "All_Promotion_Landing_body1_message8": "定価",
        "All_Promotion_Landing_body1_message9": "ライセンスは前払いで1回のみ決済され、自動更新はされません。",
        "All_Promotion_Landing_body1_message10": "決済のキャンセル及び払い戻しは、「トドさんすうホームページ > ヘルプ > お問い合わせ」からご連絡ください。\n（決済後7日以内にご連絡いただいた場合は全額払い戻し、決済後7日を超過し90日以内にご連絡いただいた場合は日割り計算で一部払い戻し、決済後90日を超過した場合は払い戻しいたしかねます。）",
        "All_Promotion_Landing_body1_message11": "購入する",
        "All_Promotion_Landing_body1_message12": "トドさんすうライセンスの決済が正常に行われました。\n購入履歴は、トドさんすうアプリ > 保護者ページ > でご確認いただけます。"
    }
}


// WEBPACK FOOTER //
// ./src/text/promotion/laptop.js